export enum OrderPaymentStatus {
  NOT_PAID, AUTHORIZED, COMPLETED, DECLINED
}
